export default __webpack_public_path__ + "static/media/md-card-bg-track-genai.6acbbe33.png";